import axios from "axios";

export default class {
  static getByProjectId = async (projectId) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/tabs/all`, {
        projectId: projectId,
      })
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static add = async (obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/tabs`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static update = async (obj) => {
    let result = {
      data: null,
      error: null,
    };

    const fd = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      fd.append(key, value);
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/tabs/${obj.id}`, fd)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static get = async (id, isInnerView, viewPortWidth) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/tabs/${id}?isInnerView=${isInnerView}&viewPortWidth=${viewPortWidth}`
      )
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };

  static delete = async (id) => {
    let result = {
      data: null,
      error: null,
    };

    await axios
      .delete(`${process.env.REACT_APP_API_URL}/tabs/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          result.data = resp.data;
        }
      })
      .catch((err) => {
        result.error = err.response.data;
      });

    return result;
  };
}
